import React from 'react'
import {BMC_BLOCKS} from "../../common_components/bmc/bmc_constants";


export function getBlockCardsAsHTMLOptions(blockStore, blockName) {
    const rootStore = blockStore.rootStore;

    const blockNameStore = rootStore.getBlockStoreByName(blockName);

    let options = [];

    if (blockNameStore) {
        blockNameStore.filteredCards().map((card, index) => {
            options.push({label: _cardLabel(card), value: card});
        });
    }

    return options;

}


export function getCardsAsHTMLOptions(cards) {
    let options = [];

    //console.log('getCardsAsHTMLOptions cards: ', cards);

    if (cards) {
        cards.map((card, index) => {
            options.push({label: _cardLabel(card), value: card});
        });
    }

    return options;

}


export function getBlockCardsFromHTMLSelectedOptions(blockStore, blockName, values) {

    //const blockNameStore = blockStore.rootStore.getBlockStoreByName(blockName);
    const cards = [];


    //if (blockNameStore) {
    values.map((v, index) => {
        cards.push(v.value);
    });

    //}


    return cards;
}


export function getValuesFromHTMLSelectedOptions(options) {
    const values = [];

    options.map((v, index) => {
        values.push(v.value);
    });

    return values;
}

// must use localization on label
export function getValuesAsHTMLOptions(values) {

    let options = [];

    if (values) {
        values.map((v, index) => {
            options.push({label: v, value: v});
        });
    }

    return options;
}


export function customerSegmentCardsAsHTMLOptions(blockStore) {
    return getBlockCardsAsHTMLOptions(blockStore, BMC_BLOCKS.CUSTOMER_SEGMENTS);
}


export function valuePropositionCardsAsHTMLOptions(blockStore) {
    return getBlockCardsAsHTMLOptions(blockStore, BMC_BLOCKS.KEY_PROPOSITIONS);
}


export function getCardsFromCustomerSegmentsHTMLSelectedOptions(blockStore, values) {
    return getBlockCardsFromHTMLSelectedOptions(blockStore, BMC_BLOCKS.CUSTOMER_SEGMENTS, values)
}


export function getCardFromValuePropositionHTMLSelectedOption(blockStore, values) {
    return getBlockCardsFromHTMLSelectedOptions(blockStore, BMC_BLOCKS.KEY_PROPOSITIONS, values)
}


function _cardLabel(card) {
    if (card.name) {
        const name = card.name.substr(0, 20);

        if (card.need) {
            const need = card.need.substr(0, 20);
            return `${name} - ${need}`
        } else {
            return name;
        }
    } else if (card.description) {
        return card.description.substr(0, 20);
    } else {
        return "---";
    }
}